module.exports = __webpack_public_path__ + "img/PT.a3a29830.png";